import store from '@/store'
import api from '@/api'
import { mapTimeEntries } from '@/utils/timeEntry'

export function lazyLoadAll () {
  let oldDates = JSON.parse(JSON.stringify(store.getters.syncStatus)) || []

  store.dispatch('lp-sync-statuses/loadAll').then(() => {
    let newDates = store.getters['lp-sync-statuses/all']

    store.commit('updateSyncStatus', newDates)
    oldDates.filter(oldDate => oldDate.attributes.lastSyncedOn !== newDates.find(newDate => newDate.id === oldDate.id).attributes.lastSyncedOn).forEach(oldDate => {
      let options = {
        options: {
          'filter[last-modified-on][ge]': oldDate.attributes.lastSyncedOn
        }
      }

      store.dispatch(oldDate.id + '/loadAll', options)
    })
  })
}

export function getCurrentEntry () {
  let userId = store.state.authentication.user.id

  api.get('/active-time-entries', { params: { 'filter[user][in]': userId } }).then((response) => {
    let activeIds = response.data.data.map(timeEntry => timeEntry.id)
    let storedActiveIds = store.getters['time-entries/all'].filter(timeEntry => timeEntry.relationships.user.data.id === userId && !timeEntry.attributes.end).map(timeEntry => timeEntry.id)
    let idsToUpdate = activeIds.filter(id => !storedActiveIds.includes(id)).concat(storedActiveIds.filter(id => !activeIds.includes(id)))

    idsToUpdate.forEach(id => store.dispatch('time-entries/loadById', { id: id }))
    !idsToUpdate.length && activeIds.forEach(id => {
      mapTimeEntries([store.getters['time-entries/byId']({ id: id })])
      let task = store.getters['time-entries/byId']({id: id}).task
      getTimeRemaining(task)
    })
  })
}

export function getTimeRemaining (task) {
  if (task && task.id) {
    api.get('/tasks/' + task.id + '?command=time-remaining').then(res => {
      let hoursRemaining = res.data.timeRemaining.hoursRemaining.toFixed(1)
      store.commit('updateCurrentEntryHoursRemaining', hoursRemaining)
    })
  }
}
